import {DxControlPointInstance} from "./dx-control-point-instance";
import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";

@jsonObject()
export class DxControlPointChainInstance {

  /**
   * Строковый код: экземпляра контрольной точки \ цепочки контрольных точек: ЦКТ10 (например).
   */
  @jsonMember({constructor: String, isRequired: true})
  code: string;

  /**
   * Момент времени завершения экземпляра цепочки.
   */
  @jsonMember({constructor: Date, isRequired: false})
  finishDateTime: Date;

  /**
   * Идентификатор.
   */
  @jsonMember({constructor: Number, isRequired: true})
  id: number;

  /**
   * Наименование экземпляра контрольной точки \ цепочки контрольных точек.
   */
  @jsonMember({constructor: String, isRequired: true})
  name: string;

  /**
   * Идентификатор экземпляра бизнесс-сущности, на которую навешаны контрольныне точки.
   */
  @jsonMember({constructor: Number, isRequired: true})
  objectId: number;

  /**
   * Идентификатор типа бизнесс-сущности, на которую навешаны контрольныне точки.
   */
  @jsonMember({constructor: Number, isRequired: true})
  objectTypeId: number;

  /**
   * Порядок.
   */
  @jsonMember({constructor: Number, isRequired: false})
  ord: number;

  // pattern: DxControlPointChainPattern;

  @jsonArrayMember(DxControlPointInstance, {isRequired: true})
  points: DxControlPointInstance[];

  /**
   * Момент времени создания\запуска экземпляра цепочки.
   */
  @jsonMember({constructor: Date, isRequired: true})
  startDateTime: Date;

  /**
   * Id пользователя, создавшего экземпляр цепочки КТ по данному экземпляру бизнесс-сущности (Он может орассматриваться как контролер выполнения).
   */
  supervisorId: number;

  @jsonMember({constructor: String, isRequired: false})
  supervisorEmail: string;

  @jsonMember({constructor: String, isRequired: false})
  supervisorLogin: string;

  @jsonMember({constructor: String, isRequired: false})
  supervisorName: string;

  @jsonMember({constructor: String, isRequired: false})
  supervisorPosition: string;

}
